import React, { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toast } from "sonner";
import logo from "@/assets/bubble-radar-logo.png";
import { Link } from "react-router-dom";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const LOGO_URL = logo;

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/auth/request-password-reset`, { email });
      toast.success("If that email exists, a reset link was sent.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Failed to send reset email");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="w-full max-w-md -mt-6">
        <div className="flex justify-center mb-10" data-testid="forgot-password-logo-wrapper">
          <img
            src={LOGO_URL}
            alt="Bubble Radar logo"
            data-testid="forgot-password-logo"
            className="h-40 w-auto"
          />
        </div>
        <Card className="w-full">
        <CardHeader>
          <CardTitle className="text-lg">Reset password</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={onSubmit} className="space-y-4">
            <div className="space-y-2">
              <label htmlFor="email" className="text-sm text-slate-600">Email</label>
              <Input
                id="email"
                data-testid="forgot-password-email-input"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                required
              />
            </div>
            <Button
              type="submit"
              data-testid="forgot-password-submit-button"
              className="w-full bg-slate-900 hover:bg-slate-800"
              disabled={loading}
            >
              {loading ? "Sending..." : "Send reset link"}
            </Button>
            <div className="text-sm text-slate-600 text-center">
              <Link to="/login" className="hover:text-slate-900" data-testid="forgot-password-login-link">
                Back to login
              </Link>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  </div>
  );
}
